import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { Supporter } from '../../../../api/generated/data-contracts';
import { GET_HELP_SUPPORT } from '../../../../constants/queryKeys';

export function useSupporters(
    options?: Omit<UseQueryOptions<Supporter[], unknown, Supporter[], string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) {
    return {
        ...useQuery({
            queryKey: [GET_HELP_SUPPORT],
            queryFn: () => ApiCalls.getSupporters({}).then(res => res.data.toSorted((a, b) => (a.order < b.order ? -1 : 1))),
            ...(options || {}),
        }),
        queryKey: [GET_HELP_SUPPORT],
    };
}
